import { appReducer } from './reducer'
import { configureStore } from '@reduxjs/toolkit'

// const persistConfig = {
//     key: 'root',
//     storage,
// }
// const persistedReducer = persistReducer(persistConfig, appReducer)
const store = configureStore({ reducer: appReducer, middleware: 
    (getDefaultMiddleware) => [...getDefaultMiddleware()]
})
// const persistor = persistStore(store)
const appStore = { store };

export default appStore